"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetEmployeeSummaryParams () {
        return GetEmployeeSummaryParams;
    },
    get GetEmployeeSummaryQuery () {
        return GetEmployeeSummaryQuery;
    },
    get RegenerateEmployeeSummaryBody () {
        return RegenerateEmployeeSummaryBody;
    }
});
const _zod = require("zod");
const _response = require("./response");
const GetEmployeeSummaryParams = _zod.z.object({
    id: _zod.z.string()
});
const GetEmployeeSummaryQuery = _zod.z.object({
    timeframe: _response.TimeframeSchema.optional().default("all")
});
const RegenerateEmployeeSummaryBody = _zod.z.object({
    timeframe: _response.TimeframeSchema.optional().default("all")
});
